var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploads(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_youruploads_l",
    clipPath: "url(#clip0_248_896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 26863"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclude",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.27789 5.00203C1.10156 5.1775 1.00174 5.4149 1 5.66293V20.7873C1 21.0358 1.09926 21.2742 1.27596 21.4501C1.45267 21.6259 1.69237 21.7248 1.9424 21.7251H19.0576C19.3071 21.7231 19.5458 21.6236 19.7221 21.4482C19.8984 21.2727 19.9983 21.0353 20 20.7873V5.66293C20 5.14538 19.5782 4.7251 19.0576 4.7251H1.9424C1.69291 4.72708 1.45422 4.82655 1.27789 5.00203ZM11 9L15 13H12V17H10V13H7L11 9Z",
    fill: "#001E36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 14L23 4.5C23 3.11929 21.8807 2 20.5 2L7 2L7 4L20.5 4C20.7761 4 21 4.22386 21 4.5L21 14L23 14Z",
    fill: "#001E36"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_248_896"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploads);
export default __webpack_public_path__ + "static/media/uploads.3fa2762e2dbf85596c2fe2f144497b8d.svg";
export { ForwardRef as ReactComponent };